import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { TextButton, Toast, useToast } from '@zillow/constellation-10';

import { Property } from '../../../models';
import { usePropertyInfoQuery } from '../../../utils/queries';
import { RENTER_HUB_ROOT } from '../../../constants/routeConstants';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

type Props = {
  isColandlord?: boolean;
};

export function DotloopLeaseUnsupportedToast({ isColandlord }: Props) {
  const history = useHistory();
  const location = useLocation();
  const { enqueueToast } = useToast();
  const { propertyId } = useLeasingUrlParams();

  const isTenant = location.pathname.includes(RENTER_HUB_ROOT);

  const propertyQuery = usePropertyInfoQuery(propertyId ?? '', !!propertyId && !isColandlord && !isTenant);
  const propertyData = propertyQuery.data;

  useEffect(() => {
    if (isColandlord) {
      enqueueToast(
        <Toast tone="critical">We no longer support this lease, contact your co-landlord for next steps</Toast>,
      );
    } else if (isTenant) {
      enqueueToast(
        <Toast tone="critical">We no longer support this lease, contact your landlord for next steps</Toast>,
      );
    }
  }, [isColandlord, isTenant, enqueueToast]);

  useEffect(() => {
    if (!isColandlord && !isTenant && propertyData) {
      const property = new Property(propertyData);
      if (property.listingAlias) {
        enqueueToast(
          <Toast
            tone="critical"
            actionButton={
              <TextButton
                onImpact
                onClick={() => history.push(Property.getCombinedOnboardingPath(property.listingAlias))}
              >
                Create lease
              </TextButton>
            }
          >
            We no longer support this lease. Create a new lease to continue.
          </Toast>,
        );
        history.push(Property.getLeasesDashboardPath(property.listingAlias));
      }
    }
  }, [isColandlord, isTenant, propertyData, enqueueToast, history]);

  return null;
}

export default DotloopLeaseUnsupportedToast;
